import React from 'react'
import { useSelector } from 'react-redux'

import { isFree } from 'data/organizations/selectors'

import {
  isCurrentUserTheOwner,
  canCurrentUserManageOrganization,
} from 'data/users/selectors'

import { SettingsOrganizationsInformationsLayoutBody } from './LayoutBody'

import Informations from './Informations'
import Sharing from './Sharing'
import Join from './Join'
import Backup from './Backup'
import DeleteTeam from './DeleteTeam'

export function SettingsOrganizationsInformations() {
  const organizationIsFree = useSelector(isFree)
  const canManage = useSelector(canCurrentUserManageOrganization)
  const isOwner = useSelector(isCurrentUserTheOwner)

  return (
    <SettingsOrganizationsInformationsLayoutBody
      organizationIsFree={organizationIsFree}
      isOwner={isOwner}
      canManage={canManage}
      Informations={Informations}
      Join={Join}
      Backup={Backup}
      DeleteTeam={DeleteTeam}
      Sharing={Sharing}
    />
  )
}
